export default {
    // http://localhost:8000/api
    API_ENDPOINT : 'https://thinkful-final-capstone.herokuapp.com/api',
    WS_ENDPOINT : 'wss://thinkful-final-capstone.herokuapp.com',
    TOKEN_KEY: 'capstone-auth-token',
  }